import { applyMiddleware, createStore as createReduxStore, Middleware } from 'redux';
import { createLogger } from 'redux-logger';
import { Subject } from 'rxjs';
import { NotificationOptions } from 'components/elements';
import { createEpicMiddleware, createRootEpic } from './epics';
import { createRootReducer, State } from './reducers';

/**
 * Create and configure Redux logger middleware
 */
const createLoggerMiddleware = (): Middleware => {
  return createLogger({
    collapsed: true,
    duration: true,
  }) as Middleware;
};


/**
 * Create Redux store
 *
 * @param {Subject<NotificationOptions>} notification$ System notification observable
 */
export const createStore = (notification$: Subject<NotificationOptions>) => {
  // Redux middleware container
  const middleware: Array<Middleware> = [];

  // Register logger middleware
  // eslint-disable-next-line no-extra-boolean-cast
  if (Boolean(parseInt(process.env.REACT_APP_REDUX_LOGGER ?? '0'))) {
    middleware.push(createLoggerMiddleware());
  }

  // Register Redux Observable middleware
  const epicMiddleware = createEpicMiddleware(notification$);
  middleware.push(epicMiddleware);

  // Instantiate the store
  const store = createReduxStore(createRootReducer(), applyMiddleware(...middleware));

  // Initialise the root observable epic
  epicMiddleware.run(createRootEpic());

  return store;
};

export type { State };
